module.exports = __webpack_public_path__ + "static/media/info-icon.4465d420.svg";